<template>
  <div>
    <template v-for="(value,name) in formButtonObj">
      <el-button :plain="value.plain" v-if="value.show" :key="name" :type="value.type" :loading="value.loading" :disabled="value.disabled" @click="handleClick(name)">{{value.name}}</el-button>
    </template>
  </div>
</template>
<script>
export default {
  props: ['formButtonObj'],
  methods: {
    handleClick(type) {
      this.$emit('clickType', type)
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
